import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthLayoutIndex from "../../layout/auth/AuthLayoutIndex";
import RootState from "../../redux/type";
import { forgotPasswordAdmin } from "../../redux/userAuth";
import { ALL_ROUTES } from "../../routes/AllRoutes";
import "../../styles/auth/Login.css";
import VerifyOtpModal from "./modals/VerifyOtpModal";
import { toast } from "../../components/razor-reuse/toast/RazorToast";
import RazorInputField from "../../components/razor-reuse/inputField/RazorInputField";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);
  type modalProps = {
    confirm: boolean;
  };
  const [showModal, setShowModal] = useState<modalProps>({
    confirm: false,
  });

  type detailsProps = {
    email: string;
    password: string;
    password_confirmation: string;
  };

  const [details, setDetails] = useState<detailsProps>({
    email: "",
    password: "",
    password_confirmation: "",
  });

  const handleChange = (e: any) => {
    e?.preventDefault?.();
    const { name, value } = e?.target;

    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const verifyEmailFunc = async () => {
    const obj = { email: details?.email };
    const data = await dispatch(forgotPasswordAdmin(obj) as any);
    if (data?.payload?.data?.status) {
      // toast.success(data?.payload?.data?.message);
      setShowModal((prev) => {
        return { ...prev, confirm: true };
      });
    }
    if (data?.payload?.response?.data?.status === "failed") {
      const messg = data?.payload?.response?.data?.errors?.email;
      toast.error(messg);
    }
  };

  return (
    <>
      <AuthLayoutIndex
        text={`Input your official email below \n A 4 digit code will be sent to the provided email`}
        title="Let’s help you recover your account"
      >
        <div className="auth-login-wrapper-box">
          <form
            action=""
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className="form"
            autoComplete="off"
          >
            <RazorInputField
              value={details?.email}
              name="email"
              onChange={handleChange}
              color="black-light"
              type="email"
              label="Email"
              placeholder="Enter email"
            />
            {/* <RazorInputField
              color="black-light"
              type="password"
              label="password"
            /> */}

            <RazorInputField
              className="submit-btn"
              color="black-light"
              type="submit"
              value={`Confirm`}
              disabled={!details?.email}
              onSubmit={verifyEmailFunc}
              loading={loading}
            />
          </form>
          {/* dont have account start */}
          <div style={{ marginTop: "3rem" }} className="down-text-box">
            <p className="text">
              Remember Password?{" "}
              <span
                onClick={() => {
                  navigate(ALL_ROUTES?.LOGIN);
                }}
              >
                Login
              </span>
            </p>
          </div>
          {/* dont have account end */}
        </div>
      </AuthLayoutIndex>
      {/* modal start */}
      <VerifyOtpModal
        visible={showModal?.confirm}
        detail={details}
        onClose={() => {
          //   setStep(1);
          setShowModal((prev) => {
            return { ...prev, confirm: false };
          });
        }}
      />
      {/* modal end */}
    </>
  );
};

export default ForgotPassword;
